import React, { Component } from 'react';
import PropTypes from "prop-types"
import Img from "gatsby-image"
import HeaderStyles from './Header.module.scss'
import BasicLayout from "../../layouts/BasicLayout";
import FullWidthLayout from "../../layouts/FullWidthLayout";
import styled from "styled-components";
import {brk} from "../../styles/constants";


const Slide = styled.div`
    position: relative;
	width: 100%;
	
	display : block;
	&.hide{
	    display : none !important;
	}
	&show{
	
	    z-index : 2;
	}
	&show-under{
	    z-index : 1;
	}
	
	&.slide-enter{
		animation: slideIn 6s;
		-moz-animation: slideIn 6s;
		width: 100%;
		top: 0;
		left: 0;
		right: 0;
	}
	&.slide-leave{
		animation: slideOut 6s;
		-moz-animation: slideOut 6s;
		position: absolute;
		width: 100%;
		top: 0;
		left: 0;
		right: 0;

	}
	

	@keyframes slideIn{
		from{
			/*transform: translateX(100%);*/
			margin-left: 100%;
		}to{
			/*transform: translateX(0);*/
			margin-left: 0;
		}
	}
	@-moz-keyframes slideIn{
		from{
			/*transform: translateX(100%);*/
			margin-left: 100%;
		}to{
			/*transform: translateX(0);*/
			margin-left: 0;
		}
	}
	@-webkit-keyframes slideIn{
		from{
			/*transform: translateX(100%);*/
			margin-left: 100%;
		}to{
			/*transform: translateX(0);*/
			margin-left: 0;
		}
	}
	@keyframes slideOut{
		from{
			/*transform: translateX(0%);*/
			margin-left: 0;
		}to{
			/*transform: translateX(-100%);*/
			margin-left: -100%;
		}
	}
	@-moz-keyframes slideOut{
		from{
			/*transform: translateX(0%);*/
			margin-left: 0%;
		}to{
			/*transform: translateX(-100%);*/
			margin-left: -100%;
		}
	}
	@-webkit-keyframes slideOut{
		from{
			/*transform: translateX(0%);*/
			margin-left: 0%;
		}to{
			/*transform: translateX(-100%);*/
			margin-left: -100%;
		}
	}
`;
const Slider = styled.div`
    display : block;
    width : 100%;
    overflow : hidden;
    
    @media (max-width : ${brk.S}){
        height : 400px;
    }
    
`;
const BackgroundImage = styled.div`
    width: 100%;
    height: 100%;
	min-height: 700px;
	max-height : 60vw;
	position: relative;
	display: flex;
	background-position : center !important;
	background-size: cover !important;
	//background-attachment: fixed !important;
    justify-content : center;
    align-items : flex-end;
    
    @media (max-width : ${brk.S}){
        min-height: 400px;
        max-height : 400px;
        height : 400px;
        background-size:auto 500px !important;
        background-position : top !important;
    }
`;

class Header extends Component {

  constructor (props) {
        super(props);
        this.state = {
            slideCount : props.data.length,
            index: 1,
            transition: null
        };
    }

    next = () => {
      console.log('next');
      if(this.state.index == ( this.state.slideCount - 1 ) ){

          this.setState({ index : 1,
              transition : 'slide'
          });
      }else{
          this.setState({ index : this.state.index + 1,
              transition : 'slide'
          });
      }



    }

    prev = () => {
        this.setState({ index : this.state.index - 1,
            transition : 'slide'
        });
        if(this.state.index <= this.state.slideCount ){
            this.setState({ index : this.state.slideCount - 1});
        }

    }

    componentDidMount(){
        this.intervalId = setInterval(this.next.bind(this), 8000);
    }

    componentWillUnmount() {
        // Clear the interval right before component unmount
        clearInterval(this.intervalId);
    }

    getTransition(index, slideCount){

      if(index == this.state.index){
          return 'slide-enter'
      }
      else if(index == (this.state.index - 1 )  && this.state.index > 0 ){
          return 'slide-leave'
      }
      else if(index == (slideCount - 1 ) && this.state.index == 0 ){
          return 'slide-leave'
      }else{
          return ''
      }
    }

    getShow(index, slideCount){
      console.log('slideCount', slideCount);
       if(index == this.state.index){
           return 'show';
       }
       if(index == ( this.state.index - 1) && this.state.index != 0){
           return 'show';
       }
       if( this.state.index == 0 && index == ( slideCount- 1 ) ){
           return 'show-under';
       }

        return 'hide'
    }


    render(){
        const {data } = this.props;




        return (
            <FullWidthLayout style={{overflow : 'hidden'}}>
                <Slider>
                    {

                        data.map((slide, i) =>
                            <Slide className={[   this.getTransition(i, data.length), this.getShow(i, data.length) ]}   >
                                <BackgroundImage className={''}   style={{ backgroundImage: `url(${slide.fluid.src})`}}
                                >
                                </BackgroundImage>
                            </Slide>
                        )

                    }
                </Slider>
            </FullWidthLayout>

        )
    }




}

export default Header;
